<template>
    <Transition name="slide-up">
        <form class="form-info" @submit.prevent="handleSubmit" v-if="!isProcessing && show">
            <!-- Header Section -->
            <div class="form-header">
                <div class="header-icon">
                    <i class="icon-business">🏢</i>
                </div>
                <h2>Business Permit Application</h2>
                <p>Complete your business registration details</p>
            </div>

            <!-- Application Type Section -->
            <div class="form-section">
                <div class="section-header">
                    <div class="section-number">1</div>
                    <h3>Application Details</h3>
                </div>
                <div class="row g-3">
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Application Type</label>
                            <select ref="appTypeRef" class="form-select modern-select" required
                                v-model="loadedData.permitInfo.type">
                                <option value="" selected disabled>Select Type</option>
                                <option value="New">New</option>
                                <option value="Renewal">Renewal</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Payment Mode</label>
                            <select class="form-select modern-select" required
                                v-model="loadedData.permitInfo.mode_of_payment">
                                <option selected disabled>Mode of Payment</option>
                                <option v-for="(mp, index) in paymentModes" :key="`mp${index}`">
                                    {{ mp }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div v-if="loadedData.permitInfo.type === 'Renewal'" class="col-12 col-md-6 col-lg-6">
                        <div class="form-group">
                            <label class="form-label">BIN</label>
                            <div class="input-group">
                                <input
                                    :readonly="loadedData.application.bin !== null && loadedData.application.bin !== ''"
                                    class="form-control modern-input" v-model="loadedData.application.look_up_bin" />
                                <button
                                    :disabled="loadedData.application.bin !== null && loadedData.application.bin !== ''"
                                    @click="lookupBin" type="button" class="btn btn-secondary input-btn">Link</button>
                            </div>
                        </div>
                        <div v-if="linkerrrmsg !== null" class="text-danger">
                            {{ linkerrrmsg }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Registration Details -->
            <div class="form-section">
                <div class="section-header">
                    <div class="section-number">2</div>
                    <h3>Registration Details</h3>
                </div>
                <div class="row g-3">
                    <div class="col-12">
                        <div class="form-group">
                            <label class="form-label">DTI/SEC/CDA Registration</label>
                            <div class="input-group modern-input-group">
                                <span class="input-group-text">
                                    <i class="icon-calendar">📅</i>
                                    Registration Date
                                </span>
                                <input class="form-control modern-input" type="date"
                                    v-model="loadedData.permitInfo.dti_sec_cda_reg_date" />
                                <input class="form-control modern-input" placeholder="Registration Number"
                                    v-model="loadedData.dti_sec_cda_reg_no" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Business Information -->
            <div class="form-section">
                <div class="section-header">
                    <div class="section-number">3</div>
                    <h3>Business Information</h3>
                </div>
                <div class="row g-3">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Organization Type</label>
                            <div class="input-group modern-input-group">
                                <span class="input-group-text">
                                    <i class="icon-org">🏛️</i>
                                </span>
                                <select v-model="loadedData.permitInfo.form_of_org" class="form-select modern-select">
                                    <option :value="org" v-for="org, index in orgs" :key="`org${index}`">
                                        {{ org }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">TIN Number</label>
                            <div class="input-group modern-input-group">
                                <span class="input-group-text">
                                    <i class="icon-tin">🔢</i>
                                </span>
                                <input type="text" class="form-control modern-input"
                                    v-model="loadedData.permitInfo.tin" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Trade Name</label>
                            <div class="input-group modern-input-group">
                                <span class="input-group-text">
                                    <i class="icon-trade">🏷️</i>
                                </span>
                                <input type="text" class="form-control modern-input"
                                    v-model="loadedData.permitInfo.trade_name" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-12 col-lg-8">
                        <div class="form-group">
                            <label class="form-label">Business Name</label>
                            <div class="input-group modern-input-group">
                                <span class="input-group-text">
                                    <i class="icon-business">💼</i>
                                </span>
                                <input type="text" class="form-control modern-input"
                                    v-model="loadedData.permitInfo.business_name" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Franchise/IPO</label>
                            <div class="input-group modern-input-group">
                                <span class="input-group-text">
                                    <i class="icon-franchise">⚡</i>
                                </span>
                                <select type="text" class="form-select modern-select"
                                    v-model="loadedData.permitInfo.franchise_or_ipo">
                                    <option>Franchise</option>
                                    <option>IPO</option>
                                    <option>None</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Main Office Address -->

            <div class="form-section">
                <div class="section-header">
                    <div class="section-number">4</div>
                    <h3>Main Office Address</h3>
                </div>

                <div class="row g-3">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Unit No.</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.unit_no" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Building Name</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.building_name" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Block/Lot No.</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.block_no_lot_no" />
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label class="form-label">Street</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.street" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label class="form-label">Subdivision</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.subdivision" />
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Province</label>
                            <select @change="handlePermitInfoProvinceChanged" class="form-select modern-select"
                                v-model="loadedData.permitInfo.province">
                                <option :value="province.value" v-for="(province, index) in provinces"
                                    :key="`pr${index}`">
                                    {{ province.label }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">City</label>
                            <select style="color: black;" @change="handlePermitInfoMunChanged"
                                class="form-select modern-select" v-model="loadedData.permitInfo.city">
                                <option :value="mun.value" v-for="mun in mun_cit" :key="`pi${mun.code}`">{{ mun.value }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Barangay</label>
                            <select class="form-select modern-select" v-model="loadedData.permitInfo.barangay">
                                <option :value="brgy.value" v-for="brgy in bpinfo_brgys" :key="`pi${brgy.code}`">{{
                                    brgy.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">ZIP Code</label>
                            <input type="text" class="form-control modern-input" v-model="loadedData.permitInfo.zip" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- Owner Information -->
            <div class="form-section">
                <div class="section-header">
                    <div class="section-number">5</div>
                    <h3>Owner Information</h3>
                </div>

                <div class="row g-3">
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">First Name</label>
                            <input type="text" class="form-control modern-input" required
                                v-model="loadedData.permitInfo.owner_firstname" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Last Name</label>
                            <input type="text" class="form-control modern-input" required
                                v-model="loadedData.permitInfo.owner_lastname" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Middle Name</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.owner_middlename" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Suffix</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.owner_suffix" />
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-12 col-lg-8">
                        <div class="form-group">
                            <label class="form-label">Citizenship</label>
                            <input type="text" class="form-control modern-input" required
                                v-model="loadedData.permitInfo.owner_citizenship" />
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Gender</label>
                            <select type="text" class="form-select modern-select" required
                                v-model="loadedData.permitInfo.owner_sex">
                                <option>Male</option>
                                <option>Female</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Owner Address -->
            <div class="form-section">
                <div class="section-header">
                    <div class="section-number">6</div>
                    <h3>Owner Address</h3>
                    <button type="button" @click="copyFromBusinessAddress" class="btn btn-link">Same As Business
                        Address</button>
                </div>

                <!-- Similar address structure as main office -->
                <div class="row g-3">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Unit No.</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.owner_unit_no" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Building Name</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.owner_building_name" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Block/Lot No.</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.owner_block_no_lot_no" />
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label class="form-label">Street</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.owner_street" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label class="form-label">Subdivision</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.owner_subdivision" />
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Province</label>
                            <select @change="handleOwnerProvinceChanged" class="form-select modern-select"
                                v-model="loadedData.permitInfo.owner_province">
                                <option :value="province.value" v-for="province in provinces"
                                    :key="`op${province.code}`">{{ province.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">City</label>
                            <select @change="handleOwnerMunChanged" class="form-select modern-select"
                                v-model="loadedData.permitInfo.owner_city">
                                <option :value="mun.value" v-for="mun in owner_muns" :key="`om${mun.code}`">{{ mun.label
                                    }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Barangay</label>
                            <select class="form-select modern-select" v-model="loadedData.permitInfo.owner_barangay">
                                <option v-for="brgy in owner_brgys" :key="`ob${brgy.code}`">{{ brgy.value }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">ZIP Code</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.permitInfo.owner_zip" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="section-header">
                    <div class="section-number">7</div>
                    <h3>Contact Person(s)</h3>
                </div>

                <!-- Contact Input Form -->
                <div class="contact-input-card">
                    <div class="row g-3">
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label class="form-label">First Name</label>
                                <input ref="contactFNameRef" type="text" class="form-control modern-input"
                                    :required="!loadedData.contacts || loadedData.contacts.length === 0"
                                    v-model="contact.firstname" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Last Name</label>
                                <input type="text" class="form-control modern-input"
                                    :required="!loadedData.contacts || loadedData.contacts.length === 0"
                                    v-model="contact.lastname" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Middle Name</label>
                                <input type="text" class="form-control modern-input" v-model="contact.middlename" />
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Suffix</label>
                                <input type="text" class="form-control modern-input" v-model="contact.suffix" />
                            </div>
                        </div>
                    </div>

                    <div class="row g-3 mt-2">
                        <div class="col-12 col-lg-4">
                            <div class="form-group">
                                <label class="form-label">Mobile No</label>
                                <input type="text" class="form-control modern-input"
                                    :required="!loadedData.contacts || loadedData.contacts.length === 0"
                                    v-model="contact.mobile" />
                            </div>
                        </div>
                        <div class="col-12 col-lg-5">
                            <div class="form-group">
                                <label class="form-label">Email</label>
                                <input type="text" class="form-control modern-input"
                                    :required="!loadedData.contacts || loadedData.contacts.length === 0"
                                    v-model="contact.email" />
                            </div>
                        </div>
                        <div class="col-12 col-lg-3">
                            <div class="form-group">
                                <label class="form-label">Gender</label>
                                <select type="text" class="form-select modern-select"
                                    :required="!loadedData.contacts || loadedData.contacts.length === 0"
                                    v-model="contact.sex">
                                    <option>Male</option>
                                    <option>Female</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- Action Buttons -->
                    <div class="contact-actions">
                        <button type="button" class="btn btn-add-contact" @click="addContact">
                            <i class="bi bi-person-plus"></i>
                            Add Contact
                        </button>
                        <button type="button" class="btn btn-clear-contact" @click="clearContact">
                            <i class="bi bi-arrow-clockwise"></i>
                            Clear Form
                        </button>
                    </div>
                </div>

                <!-- Contacts List -->
                <div v-if="loadedData.contacts && loadedData.contacts.length > 0" class="contacts-list-section">
                    <div class="contacts-header">
                        <h4>Contact Persons</h4>
                        <span class="contacts-count">{{ loadedData.contacts.length }} contact(s)</span>
                    </div>

                    <div class="contacts-grid">
                        <div class="contact-card" v-for="(contact, index) in loadedData.contacts" :key="index">
                            <div class="contact-header">
                                <div class="contact-avatar">
                                    {{ getInitials(contact.firstname, contact.lastname) }}
                                </div>
                                <div class="contact-info">
                                    <h5 class="contact-name">
                                        {{ contact.firstname }} {{ contact.middlename }} {{ contact.lastname }} {{
                                            contact.suffix || '' }}
                                    </h5>
                                    <p class="contact-role">Contact Person</p>
                                </div>
                                <button class="btn-remove-contact" @click="removeContact(index)" title="Remove contact">
                                    <i class="bi bi-x-lg"></i>
                                </button>
                            </div>

                            <div class="contact-details">
                                <div class="contact-detail">
                                    <i class="bi bi-telephone"></i>
                                    <span>{{ contact.mobile }}</span>
                                </div>
                                <div class="contact-detail">
                                    <i class="bi bi-envelope"></i>
                                    <span>{{ contact.email }}</span>
                                </div>
                                <div class="contact-detail">
                                    <i class="bi bi-gender-ambiguous"></i>
                                    <span>{{ contact.sex }}</span>
                                </div>
                            </div>

                            <div class="contact-footer">
                                <span class="contact-index">#{{ index + 1 }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center" v-else>
                    <div class="alert alert-danger">
                        ⚠️ Add Contact to proceed.
                    </div>
                </div>
            </div>

            <div class="form-section">
                <div class="section-header">
                    <div class="section-number">8</div>
                    <h3>Business Operations</h3>
                    <button type="button" @click="copyOperationFromBusinessAddress" class="btn btn-link">Same As
                        Business Address</button>
                </div>
                <div class="row g-3">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Area in sqm.</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.area_sqm" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Total Male Employees.</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.no_of_employees" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Total Female Employees</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.no_females" />
                        </div>
                    </div>
                </div>
                <div class="row g-3 mt-2" style="margin-bottom: 1rem;">
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">No. of Delivery Vehicles</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.no_delivery_vehicles" />
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">No. of Employees Residing in LGU</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.no_emp_residing_lgu" />
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Rental or Owned.</label>
                            <select class="form-select modern-select" v-model="loadedData.businessInfo.rental_or_owned">
                                <option>Rental</option>
                                <option>Owned</option>
                            </select>
                        </div>
                    </div>
                </div>

                <!-- Similar address structure as main office -->
                <div class="row g-3 top-divider mt-2">
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Unit No.</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.operation_unit_no" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Building Name</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.operation_building_name" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="form-group">
                            <label class="form-label">Block/Lot No.</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.operation_block_no_lot_no" />
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label class="form-label">Street</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.operation_street" />
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label class="form-label">Subdivision</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.operation_subdivision" />
                        </div>
                    </div>
                </div>

                <div class="row g-3 mt-2">
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Province</label>
                            <select @change="handleBusinessInfoProvChanged" class="form-select modern-select"
                                v-model="loadedData.businessInfo.operation_province">
                                <option :value="province.value" v-for="province in provinces"
                                    :key="`bip${province.code}`">{{ province.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">City</label>
                            <select @change="handleBusinessInfoMunChanged" class="form-select modern-select"
                                v-model="loadedData.businessInfo.operation_city">
                                <option :value="mun.value" v-for="mun in businfo_muns" :key="`bim${mun.code}`">{{
                                    mun.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">Barangay</label>
                            <select class="form-select modern-select"
                                v-model="loadedData.businessInfo.operation_barangay">
                                <option :value="brgy.value" v-for="brgy in businfo_brgys" :key="`bib${brgy.code}`">{{
                                    brgy.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="form-label">ZIP Code</label>
                            <input type="text" class="form-control modern-input"
                                v-model="loadedData.businessInfo.operation_zip" />
                        </div>
                    </div>
                </div>

            </div>

            <LineOfBusiness :apptype="loadedData.permitInfo.type" @apptype-required="handleAppTypeRequired"
                @lob-modified="handleLobModification" :lobs="loadedData.permitLineOfBusinesses" />

            <!-- Submit Button -->
            <div class="form-actions">
                <button type="submit" class="btn btn-primary btn-submit">
                    <span class="btn-text">{{ loadedData?.application?.application_id === 0 ? 'Submit Application' :
                        'Save Changes' }}</span>
                    <span class="btn-icon">🚀</span>
                </button>
            </div>
        </form>
    </Transition>
    <SpinnerBlock v-if="isProcessing && show" />
    <ChildModal title="Enter Gross Sales" :show="showGrossModal" @close="toggleGrossModal" :closeable="false" :click-away="false">
        <RenewalGrossInput ref="rgiRef" @close="handleCloseGrossModal" @save="handleGrossSave" :lobs="loadedData.permitLineOfBusinesses"/>
    </ChildModal>
</template>

<script setup>
import businessService from '@/services/businessService';
import { nextTick, ref, watch } from 'vue';
import SpinnerBlock from '../animations/SpinnerBlock.vue';
import LineOfBusiness from './LineOfBusiness.vue';
import { getAllProvinces, getBarangaysByMunicipality, getMunicipalitiesByProvince } from '@/utils/philippines';
import toastService from '@/services/toastService';
import confirmationService from '@/services/confirmationService';
import ChildModal from '../modals/ChildModal.vue';
import RenewalGrossInput from '../inputs/RenewalGrossInput.vue';

//eslint-disable-next-line
const props = defineProps({
    id: {
        type: Number,
        default: 0
    },
    show: {
        type: Boolean,
        default: false
    }
});

//eslint-disable-next-line
const emit = defineEmits(['close']);

const rgiRef = ref(null);

const showGrossModal = ref(false);
const toggleGrossModal = ()=>{
    showGrossModal.value = !showGrossModal.value;
    if(showGrossModal.value){
        nextTick(()=>{
            rgiRef.value?.focus();
        })
    }
}

const handleCloseGrossModal = ()=>{
    toggleGrossModal();
    emit('close');
}

const handleGrossSave = (lobs)=>{
    loadedData.value.permitLineOfBusinesses = lobs;
    toggleGrossModal();
}
const contactFNameRef = ref(null);
const appTypeRef = ref(null);
const handleAppTypeRequired = () => {
    if (appTypeRef.value)
        nextTick(() => {
            appTypeRef.value.focus()
        });
}
const handleSubmit = async () => {
    if (loadedData.value.contacts === null || loadedData.value.contacts.length === 0) {
        toastService.error("Please add at least one contact information");
        contactFNameRef.value.focus();
        return;
    }
    if (loadedData.value.permitLineOfBusinesses === null || loadedData.value.permitLineOfBusinesses.length === 0) {
        toastService.error("Line of business required!");
        return;
    }
    if (loadedData.value.application.type === 'Renewal')
        if (loadedData.value.application.bin === null || loadedData.value.application.bin === '') {
            toastService.error("You need to link your bin first in order to proceed business renewal!");
            return;
        }
    const confirmed = await confirmationService.show('Are you sure you want to proceed?')
    if (!confirmed) return;
    const resp = await businessService.save(loadedData.value);
    if (resp.success) {
        toastService.success("Success");
    }
    else
        toastService.error(resp.message);
    emit('save-success', true);
}

const handleLobModification = (newVal) => {
    loadedData.value.permitLineOfBusinesses = newVal;
    console.log('newval', newVal)
    //loadedData.value.permitLineOfBusinesses.push(item);
}

const handlePermitInfoProvinceChanged = () => {
    mun_cit.value = getMunicipalitiesByProvince(loadedData.value.permitInfo.province);
}

const handlePermitInfoMunChanged = () => {
    bpinfo_brgys.value = getBarangaysByMunicipality(loadedData.value.permitInfo.city);
}

const handleOwnerProvinceChanged = () => {
    owner_muns.value = getMunicipalitiesByProvince(loadedData.value.permitInfo.owner_province);
}

const handleOwnerMunChanged = () => {
    owner_brgys.value = getBarangaysByMunicipality(loadedData.value.permitInfo.owner_city);
}

const handleBusinessInfoProvChanged = () => {
    businfo_muns.value = getMunicipalitiesByProvince(loadedData.value.businessInfo.operation_province)
}

const handleBusinessInfoMunChanged = () => {
    businfo_brgys.value = getBarangaysByMunicipality(loadedData.value.businessInfo.operation_city);
}

const contact = ref({});
const provinces = getAllProvinces();
const mun_cit = ref([]);
const owner_muns = ref([]);
const owner_brgys = ref([]);
const bpinfo_brgys = ref([]);
const businfo_muns = ref([]);
const businfo_brgys = ref([]);
const paymentModes = ref(["Annually", "Semi-Annually", "Quarterly"]);
const orgs = ref(["Sole Proprietorship", "Partnership", "Corporation",
    "One Person Corporation", "Cooperative", "Association", "None"
]);
const loadedData = ref({
    permitInfo: { type: null },
    businessInfo: { type: null }
});
const isProcessing = ref(false);

const getBusinessInfo = async (id) => {
    if (!props.show)
        return;
    if (id > 0) {
        isProcessing.value = true;
        loadedData.value = await businessService.getBusinessInfo(id);
        loadedData.value.application = { ...loadedData.value.application, look_up_bin: loadedData.value.application.bin };
        initializeAddresses();
        isProcessing.value = false;
    }
    else {
        intitalizeLoadedData();
    }
};

const getBusinessInfoForRenewal = async (id) => {
    if (!props.show)
        return;
    if (id > 0) {
        isProcessing.value = true;
        loadedData.value = await businessService.getBusinessInfo(id);
        loadedData.value.application = { ...loadedData.value.application, look_up_bin: loadedData.value.application.bin || null };
        initializeAddresses();
        isProcessing.value = false;
        loadedData.value.application.application_id = 0;
        loadedData.value.permitInfo.type = "Renewal";
        loadedData.value.permitLineOfBusinesses?.forEach(x => {
           x.type = "Renewal"
        });
        toggleGrossModal();
    }
    else {
        intitalizeLoadedData();
    }
};

const intitalizeLoadedData = () => {
    loadedData.value = {
        "application": {
            "application_id": 0,
            "date_created": null,
            "time_created": null,
            "user_id": 0,
            "date_finished": null,
            "status": "",
            "type": "",
            "bin": "",
            "ord_num": 0,
            "year": "",
            "month": "",
            "bpermit_no": "",
            "permit_order": 0,
            "is_problem": "",
            "remarks": null,
            "renewal_status": ""
        },
        "permitInfo": {
            "bpi_id": 0,
            "application_id": 0,
            "user_id": 0,
            "type": "",
            "mode_of_payment": "",
            "application_date": null,
            "dti_sec_cda_reg_date": null,
            "dti_sec_cda_reg_no": "",
            "form_of_org": "",
            "tin": "",
            "trade_name": "",
            "business_name": "",
            "franchise_or_ipo": "",
            "unit_no": null,
            "building_name": null,
            "block_no_lot_no": null,
            "street": null,
            "subdivision": null,
            "province": "",
            "barangay": "",
            "city": "",
            "zip": "",
            "owner_lastname": "",
            "owner_firstname": "",
            "owner_middlename": "",
            "owner_suffix": "",
            "owner_citizenship": "",
            "owner_sex": "",
            "owner_unit_no": null,
            "owner_building_name": null,
            "owner_block_no_lot_no": null,
            "owner_street": null,
            "owner_subdivision": null,
            "owner_province": "",
            "owner_barangay": "",
            "owner_city": "",
            "owner_zip": ""
        },
        "businessInfo": {
            "bi_id": 0,
            "area_sqm": 0.00,
            "no_of_employees": 0,
            "no_females": 0,
            "no_delivery_vehicles": 0,
            "no_emp_residing_lgu": 0,
            "total_capital_investment": 0.00,
            "rental_or_owned": "",
            "operation_unit_no": null,
            "operation_building_name": null,
            "operation_block_no_lot_no": null,
            "operation_street": "",
            "operation_subdivision": null,
            "operation_province": "",
            "operation_barangay": "",
            "operation_city": "",
            "operation_zip": "",
            "operation_office_type": "",
            "bpi_id": 0
        },
        "permitLineOfBusinesses": [],
        "docVerificationLogs": null,
        "user": null,
        "contacts": [],
        "approvals": null,
        "barangay": {
            "sbrgy_id": 0,
            "province": "",
            "city": "",
            "barangay": "",
            "brgy_captain": "",
            "type": "",
            "garbage_zone": ""
        },
        "issuedCerts": [],
        "soaBalances": [],
        "soa": {
            "bsoa_id": 0,
            "application_id": 0,
            "soa_date": null,
            "soa_type": "",
            "date_generated": null,
            "time_generated": null,
            "date_issued": null,
            "time_issued": null,
            "status": "",
            "generated_by": 0,
            "recalculated_by": 0,
            "paid": 0,
            "date_paid": null,
            "action": "",
            "time_paid": null,
            "tax_year": ""
        },
        "paymentHistory": {
            "ph_id": 0,
            "user_id": 0,
            "al_id": 0,
            "checksum": null,
            "error_code": "",
            "lbp_conf_date": 0,
            "lbp_conf_num": "",
            "lbp_ref_num": "",
            "merchant_ref_num": "",
            "trxn_amount": 0.00,
            "trxn_details": "",
            "tran_detail_1": "",
            "tran_detail_2": "",
            "email_address": "",
            "merchant_code": "",
            "pay_option": "",
            "ph_date_created": null,
            "or_no": "",
            "or_date": null
        },
        "businessPermitData": {
            "bd_id": 0,
            "date_issued": null,
            "date_expired": null,
            "series": 0,
            "year": "",
            "application_id": 0,
            "issued_by": 0
        }
    };
}
//eslint-disable-next-line
defineExpose({
    getBusinessInfo,
    intitalizeLoadedData, getBusinessInfoForRenewal
})

const copyFromBusinessAddress = () => {
    loadedData.value.permitInfo.owner_block_no_lot_no = loadedData.value.permitInfo.block_no_lot_no;
    loadedData.value.permitInfo.owner_unit_no = loadedData.value.permitInfo.unit_no;
    loadedData.value.permitInfo.owner_street = loadedData.value.permitInfo.street;
    loadedData.value.permitInfo.owner_building_name = loadedData.value.permitInfo.building_name;
    loadedData.value.permitInfo.owner_subdivision = loadedData.value.permitInfo.subdivision;
    loadedData.value.permitInfo.owner_province = loadedData.value.permitInfo.province;
    handleOwnerProvinceChanged();
    loadedData.value.permitInfo.owner_city = loadedData.value.permitInfo.city;
    handleOwnerMunChanged();
    loadedData.value.permitInfo.owner_barangay = loadedData.value.permitInfo.barangay;
    loadedData.value.permitInfo.owner_zip = loadedData.value.permitInfo.zip;

}

const copyOperationFromBusinessAddress = () => {
    loadedData.value.businessInfo.operation_block_no_lot_no = loadedData.value.permitInfo.block_no_lot_no;
    loadedData.value.businessInfo.operation_unit_no = loadedData.value.permitInfo.unit_no;
    loadedData.value.businessInfo.operation_street = loadedData.value.permitInfo.street;
    loadedData.value.businessInfo.operation_building_name = loadedData.value.permitInfo.building_name;
    loadedData.value.businessInfo.operation_subdivision = loadedData.value.permitInfo.subdivision;
    loadedData.value.businessInfo.operation_province = loadedData.value.permitInfo.province;
    handleBusinessInfoProvChanged();
    loadedData.value.businessInfo.operation_city = loadedData.value.permitInfo.city;
    handleBusinessInfoMunChanged();
    loadedData.value.businessInfo.operation_barangay = loadedData.value.permitInfo.barangay;
    loadedData.value.businessInfo.operation_zip = loadedData.value.permitInfo.zip;
}


const initializeAddresses = () => {
    handlePermitInfoProvinceChanged();
    handlePermitInfoMunChanged();
    handleOwnerProvinceChanged();
    handleOwnerMunChanged();
    handleBusinessInfoProvChanged();
    handleBusinessInfoMunChanged();
}

const addContact = () => {
    if (!loadedData.value.contacts) {
        loadedData.value.contacts = [];
    }
    const validationErr = validateContact();
    if (validationErr !== '') {
        toastService.error(validationErr);
        return;
    }
    // Add validation logic here
    loadedData.value.contacts.push({ ...contact.value });
    clearContact();
};
const validateContact = () => {
    const rules = [
        { field: 'firstname', message: 'First Name Required', check: (val) => !val?.trim() },
        { field: 'lastname', message: 'Last Name Required', check: (val) => !val?.trim() },
        { field: 'mobile', message: 'Mobile No. Required', check: (val) => !val?.trim() },
    ];

    for (const rule of rules) {
        if (rule.check(contact.value[rule.field])) {
            return rule.message;
        }
    }

    return '';
};
const linkerrrmsg = ref(null);
const lookupBin = async () => {
    linkerrrmsg.value = null;
    if (!loadedData.value.application.look_up_bin || loadedData.value.application.look_up_bin.trim() === '')
        return;
    const resp = await businessService.lookupBin(loadedData.value.application.look_up_bin);
    if (resp.success) {
        loadedData.value.application.bin = loadedData.value.application.look_up_bin;
        toastService.success("Link successful");
    }
    else {
        linkerrrmsg.value = resp.message;
    }
}

const removeContact = (index) => {
    loadedData.value.contacts.splice(index, 1);
};

const clearContact = () => {
    contact.value = {
        firstname: '',
        lastname: '',
        middlename: '',
        suffix: '',
        mobile: '',
        email: '',
        sex: 'Male'
    };
};

const getInitials = (firstname, lastname) => {
    return `${firstname?.charAt(0) || ''}${lastname?.charAt(0) || ''}`.toUpperCase();
};

watch(
    () => props.id,
    (newVal) => {
        if (newVal == 0) {
            intitalizeLoadedData();
        }
        linkerrrmsg.value = null;
    },
    { immediate: true }
);
</script>

<style scoped>
.form-info {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 20px;
    padding: 2rem;
    box-shadow: 0 20px 60px rgba(220, 53, 69, 0.1);
    border: 1px solid rgba(220, 53, 69, 0.1);
    backdrop-filter: blur(10px);
}

/* Header Styles */
.form-header {
    text-align: center;
    margin-bottom: 3rem;
    padding-bottom: 2rem;
    border-bottom: 2px solid rgba(220, 53, 69, 0.1);
    background: linear-gradient(135deg, #dc3545, #c82333);
    border-radius: 15px;
    padding: 2rem;
    color: white;
    margin: -2rem -2rem 3rem -2rem;
}

.form-header h2 {
    font-weight: 700;
    font-size: 2rem;
    margin-bottom: 0.5rem;
}

.form-header p {
    opacity: 0.9;
    font-size: 1.1rem;
}

.header-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
}

/* Section Styles */
.form-section {
    background: white;
    border-radius: 15px;
    padding: 2rem;
    margin-bottom: 2rem;
    box-shadow: 0 5px 25px rgba(220, 53, 69, 0.08);
    border: 1px solid rgba(220, 53, 69, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.form-section:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(220, 53, 69, 0.12);
}

.section-header {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid rgba(220, 53, 69, 0.1);
}

.section-number {
    background: linear-gradient(135deg, #dc3545, #c82333);
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    margin-right: 1rem;
    font-size: 1.2rem;
}

.section-header h3 {
    color: #2c3e50;
    font-weight: 600;
    margin: 0;
}

/* Form Controls */
.form-group {
    margin-bottom: 0;
}

.form-label {
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 0.5rem;
    display: block;
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.modern-input {
    border: 2px solid #e9ecef;
    border-radius: 12px;
    padding: 0.75rem 1rem;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: white;
}

.modern-input:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    transform: translateY(-1px);
}

.modern-input-group {
    border-radius: 12px;
    overflow: hidden;
}

.modern-input-group .input-group-text {
    background: linear-gradient(135deg, #dc3545, #c82333);
    border: none;
    color: white;
    font-weight: 500;
    padding: 0.75rem 1rem;
}

.modern-input-group .form-control {
    border: 2px solid #e9ecef;
    border-left: none;
}

.modern-input-group .form-control:focus {
    border-color: #dc3545;
    border-left: none;
}

/* Submit Button */
.form-actions {
    text-align: center;
    margin-top: 3rem;
    padding-top: 2rem;
    border-top: 2px solid rgba(220, 53, 69, 0.1);
}

.top-divider {
    border-top: 2px solid rgba(220, 53, 69, 0.1);
}

.btn-submit {
    background: linear-gradient(135deg, #dc3545, #c82333);
    border: none;
    border-radius: 50px;
    padding: 1rem 3rem;
    font-size: 1.1rem;
    font-weight: 600;
    color: white;
    transition: all 0.3s ease;
    box-shadow: 0 5px 20px rgba(220, 53, 69, 0.3);
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.btn-submit:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(220, 53, 69, 0.4);
    background: linear-gradient(135deg, #c82333, #a71e2a);
}

/* Transitions */
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-enter-from {
    opacity: 0;
    transform: translateY(30px);
}

.slide-up-leave-to {
    opacity: 0;
    transform: translateY(-30px);
}

/* Responsive Design */
@media (max-width: 768px) {
    .form-info {
        padding: 1rem;
        border-radius: 15px;
        margin: 0.5rem;
    }

    .form-header {
        margin: -1rem -1rem 2rem -1rem;
        padding: 1.5rem;
    }

    .form-header h2 {
        font-size: 1.5rem;
    }

    .form-section {
        padding: 1.5rem;
    }

    .section-header {
        flex-direction: column;
        text-align: center;
        gap: 1rem;
    }

    .btn-submit {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 576px) {
    .form-info {
        padding: 1rem 0.5rem;
    }

    .form-section {
        padding: 1rem;
    }

    .row.g-3 {
        margin: 0;
    }

    .col-12 {
        padding: 0.25rem;
    }
}

/* Contact Input Card */
.contact-input-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border: 2px dashed rgba(220, 53, 69, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 2rem;
    transition: all 0.3s ease;
}

.contact-input-card:hover {
    border-color: rgba(220, 53, 69, 0.4);
    box-shadow: 0 5px 20px rgba(220, 53, 69, 0.1);
}

/* Contact Actions */
.contact-actions {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 2px solid rgba(220, 53, 69, 0.1);
}

.btn-add-contact {
    background: linear-gradient(135deg, #dc3545, #c82333);
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

.btn-add-contact:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(220, 53, 69, 0.4);
}

.btn-clear-contact {
    background: transparent;
    color: #6c757d;
    border: 2px solid #6c757d;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.btn-clear-contact:hover {
    background: #6c757d;
    color: white;
    transform: translateY(-1px);
}

/* Contacts List Section */
.contacts-list-section {
    margin-top: 2rem;
}

.contacts-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid rgba(220, 53, 69, 0.1);
}

.contacts-header h4 {
    margin: 0;
    color: #2c3e50;
    font-weight: 600;
    font-size: 1.3rem;
}

.contacts-count {
    background: linear-gradient(135deg, #dc3545, #c82333);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
}

/* Contacts Grid */
.contacts-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 1.5rem;
}

/* Contact Card */
.contact-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    box-shadow: 0 5px 25px rgba(220, 53, 69, 0.08);
    border: 1px solid rgba(220, 53, 69, 0.05);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.contact-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(220, 53, 69, 0.12);
}

.contact-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(135deg, #dc3545, #c82333);
}

/* Contact Header */
.contact-header {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.contact-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: linear-gradient(135deg, #dc3545, #c82333);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 700;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.contact-info {
    flex: 1;
}

.contact-name {
    margin: 0 0 0.25rem 0;
    color: #2c3e50;
    font-weight: 600;
    font-size: 1.1rem;
    line-height: 1.3;
}

.contact-role {
    margin: 0;
    color: #6c757d;
    font-size: 0.85rem;
    background: #f8f9fa;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    display: inline-block;
}

.btn-remove-contact {
    background: rgba(220, 53, 69, 0.1);
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #dc3545;
    cursor: pointer;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.btn-remove-contact:hover {
    background: #dc3545;
    color: white;
    transform: scale(1.1);
}

/* Contact Details */
.contact-details {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.contact-detail {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0;
}

.contact-detail i {
    color: #dc3545;
    width: 16px;
    font-size: 0.9rem;
}

.contact-detail span {
    color: #495057;
    font-size: 0.95rem;
    font-weight: 500;
}

/* Contact Footer */
.contact-footer {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(220, 53, 69, 0.1);
    display: flex;
    justify-content: flex-end;
}

.contact-index {
    background: #f8f9fa;
    color: #6c757d;
    padding: 0.25rem 0.75rem;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
    .contact-input-card {
        padding: 1.5rem;
    }

    .contact-actions {
        flex-direction: column;
        gap: 0.75rem;
    }

    .btn-add-contact,
    .btn-clear-contact {
        width: 100%;
        justify-content: center;
    }

    .contacts-grid {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .contacts-header {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
    }

    .contact-header {
        flex-direction: column;
        text-align: center;
        gap: 0.75rem;
    }

    .contact-avatar {
        align-self: center;
    }
}

@media (max-width: 576px) {
    .contact-input-card {
        padding: 1rem;
    }

    .contact-card {
        padding: 1.25rem;
    }

    .contact-details {
        gap: 0.5rem;
    }

    .contact-detail {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.25rem;
    }
}

/* Loading state */
.form-info:has(.modern-input:disabled) {
    opacity: 0.7;
    pointer-events: none;
}

/* Custom scrollbar */
.form-info::-webkit-scrollbar {
    width: 8px;
}

.form-info::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.form-info::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #dc3545, #c82333);
    border-radius: 10px;
}
</style>